export default {
  project: state => state.project,
  controls: state => state.project.player_skin && state.project.player_skin.controls,
  skin: state => state.project.player_skin,
  shareData: state => state.project.share_data,
}